export {ProjectResolve} from './project.resolve';
export {CurrentProjectResolve} from './current-project.resolve';



// WEBPACK FOOTER //
// /agent/workspace/CUS-LHT_NICE_nto_nto_CAT_develop@2/app/Resources/Public/src/app/modules/project-details/resolve/index.ts